import { Component, OnInit } from '@angular/core';
import { User } from 'app/shared/models/User';
import { IHeaderTitle } from "app/shared/models/header-title";
import { UserService } from "app/core/services/user.service";
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';

@Component({
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
    headerTitle: IHeaderTitle;
    users: User[];
    userList: User[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;

    constructor(
        private _userService: UserService,
        private fb: FormBuilder,
        private sortService: SortService
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Users' }

        this._userService.getUsers().subscribe(
            users => {
                this.users = users;
                this.userList = users;
            },
            error => {
                console.log(error);
            }
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.userList = this.sortService.filterAndSortlist(this.users, newValue, this.lastSort);
        });
    }
}
